import { getUserFullName } from '../helpers/user'
import { ISocietiesModel } from '../interfaces/models/societies.interfaces'
import { useGetResidentUsersForSociety } from '../views/society/Resident/FindFriendsView'

export const useNonBoardMemberResidentUsersOptions = (
  society: ISocietiesModel | undefined
): { value: string; label: string }[] => {
  const boardMemberIds = society?.boardMembersList
    ? society?.boardMembersList
        .map((_member) => _member.userId)
        .filter((member) => member)
    : []
  const nominatingCommitteeMemberIds = society?.nominatingCommitteeList
    ? society?.nominatingCommitteeList
        .map((_member) => _member.userId)
        .filter((member) => member)
    : []

  const boardMemberOrNominatingCommitteeMemberIds = [
    ...boardMemberIds,
    ...nominatingCommitteeMemberIds,
  ]

  const { users: residentUsers } = useGetResidentUsersForSociety(society?._id)
  const nonBoardMemberResidentUsers = residentUsers.filter(
    (_user) => !boardMemberOrNominatingCommitteeMemberIds.includes(_user._id)
  )

  const nonBoardMemberResidentUsersOptions = nonBoardMemberResidentUsers.map(
    (_user) => ({
      value: _user._id,
      label: getUserFullName(_user),
    })
  )

  return nonBoardMemberResidentUsersOptions
}
